import { Injectable, inject } from '@angular/core';
import { ConfirmDialogComponent } from './confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ConfirmDialogService {
    private dialogRef = inject(MatDialog);

    cancel(): void {
        this.dialogRef.closeAll();
    }

    async showDialog(message: string,
        title?: string,
        confirmColor: 'primary' | 'warn' | 'accent' = 'primary',
        confirmMessage = 'Bestätigen',
        cancelMessage = 'Abbrechen') {
        return firstValueFrom(
            this.dialogRef.open(ConfirmDialogComponent, {
                data: {
                    message,
                    title,
                    confirmMessage,
                    confirmColor,
                    cancelMessage,
                },
                panelClass: 'ufla-dialog-container',
            })
                .afterClosed(),
        );
    }
}
